/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4CrossDiagIcon16Solid = forwardRef('ArrowDim4CrossDiagIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5 2a1 1 0 0 1 1-1H13a2 2 0 0 1 2 2v2.5a1 1 0 1 1-2 0V4.414L9.414 8 13 11.586V10.5a1 1 0 1 1 2 0V13a2 2 0 0 1-2 2h-2.5a1 1 0 1 1 0-2h1.086L8 9.414 4.414 13H5.5a1 1 0 1 1 0 2H3a2 2 0 0 1-2-2v-2.5a1 1 0 0 1 2 0v1.086L6.586 8 3 4.414V5.5a1 1 0 0 1-2 0V3a2 2 0 0 1 2-2h2.5a1 1 0 0 1 0 2H4.414L8 6.586 11.586 3H10.5a1 1 0 0 1-1-1Z" })));
});
